import baseApi from "../../../Lib/api/baseApi";
import endpoints from "../../../Lib/api/endpoints";

export const VendorApi = baseApi.injectEndpoints({
  tagTypes: ["Vendor"],
  endpoints: (builder) => ({
    getAllVendors: builder.query({
      query: (data) => ({
        ...endpoints.getAllVendors(data),
      }),
      transformResponse: (response) => {
        const transformedData = response?.data?.data?.map((d, index) => ({
          no: index + 1,
          name: d?.businessName || d?.name || "N/A",
          email: d?.email,
          phoneNumber: d?.phoneNumber,
          activated: d?.activated,
          status: d?.status,
          id: d?.id,
          createdAt: d?.createdAt,
        }));
        return {
          data: transformedData,
          page: response?.data?.page || 0,
          total: response?.data?.total || 0,
          limit: response?.data?.limit || 0,
        };
      },
      providesTags: [{ type: "Vendor", id: "All" }],
    }),
    getVendorStats: builder.query({
      query: () => ({
        ...endpoints.getVendorStats,
      }),
      providesTags: [{ type: "Vendor", id: "Stats" }],
    }),
    getVendorById: builder.query({
      query: (id) => ({
        ...endpoints.getVendorById(id),
      }),
      providesTags: [{ type: "Vendor", id: "Single" }],
    }),
    deactivateVendor: builder.mutation({
      query: (id) => ({
        ...endpoints.deactivateVendor(id),
      }),
      invalidatesTags: [
        { type: "Vendor", id: "All" },
        { type: "Vendor", id: "Single" },
        { type: "Vendor", id: "Stats" },
      ],
    }),
    reactivateVendor: builder.mutation({
      query: (id) => ({
        ...endpoints.reactivateVendor(id),
      }),
      invalidatesTags: [
        { type: "Vendor", id: "All" },
        { type: "Vendor", id: "Single" },
        { type: "Vendor", id: "Stats" },
      ],
    }),
    approveVendor: builder.mutation({
      query: (id) => ({
        ...endpoints.approveVendor(id),
      }),
      invalidatesTags: [
        { type: "Vendor", id: "All" },
        { type: "Vendor", id: "Single" },
        { type: "Vendor", id: "Stats" },
      ],
    }),
    declineVendor: builder.mutation({
      query: (id) => ({
        ...endpoints.declineVendor(id),
      }),
      invalidatesTags: [
        { type: "Vendor", id: "All" },
        { type: "Vendor", id: "Single" },
        { type: "Vendor", id: "Stats" },
      ],
    }),
    getVendorItems: builder.query({
      query: (data) => ({
        ...endpoints.getVendorItems(data),
      }),
      providesTags: (result, error, arg) => [
        { type: "Vendor", id: `Items-${arg?.vendorId}` },
      ],
    }),
  }),
});

export const {
  useGetAllVendorsQuery,
  useGetVendorStatsQuery,
  useGetVendorByIdQuery,
  useDeactivateVendorMutation,
  useReactivateVendorMutation,
  useApproveVendorMutation,
  useDeclineVendorMutation,
  useGetVendorItemsQuery,
} = VendorApi;
